/* ============
 * State of the auth module
 * ============
 *
 * The initial state of the auth module.
 */

export default {
  panelActive: false,
}


// WEBPACK FOOTER //
// ./src/store/modules/sinisters/state.js